import { render, staticRenderFns } from "./SaldoAnualContratos.vue?vue&type=template&id=04e92070"
import script from "./SaldoAnualContratos.vue?vue&type=script&lang=js"
export * from "./SaldoAnualContratos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports